import React, { useState, useEffect } from "react";
import "./index.scss";
import FormGenerator from "../../../../core/form-generator";
import { getInternalCutInFormConfig } from "./config";
import { Box, Grid, IconButton } from "@mui/material";
import {
  getFileNameFromUrl,
  handleFormValidation,
  PAGE_LIMIT,
} from "../../../../utils";
import SiAutocomplete from "../../../../core/si-autocomplete";
import SiFileUpload from "../../../../core/file-uploader";
import CustomButtonComponent from "../../../../core/custom-button";
import {
  HTTP_METHODS,
  invokeApi,
  plainApi,
} from "../../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../../utils/endpoints";

import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { toast } from "react-toastify";
const CreateServiceInformation = ({ setIsCreate, loadData, editData }) => {
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [oemsList, setOemsList] = useState([]);
  const [files, setFiles] = useState([]);
  const [defectCodeList, setDefectCodeList] = useState([]);
  let oemTimeout = null;

  const submitHandler = () => {
    const isValid = handleFormValidation(
      getInternalCutInFormConfig(),
      setErrors,
      formData
    );

    if (isValid) {
      const payload = {
        ...formData,
        oem: formData?.oem?.value,
        uploadedDocument: files?.map((file) => file.url || file) || [],
        defectCode: formData.defectCode?.value,
      };
      if (editData?.id) {
        invokeApi(
          HTTP_METHODS.PUT,
          `${HOSTNAME}${REST_URLS.INTERNAL_CUTIN}/${editData.id}`,
          payload
        )
          .then((res) => {
            if (res.message) {
              toast.error(res.message);
            } else {
              toast.success("Cut In Info Updated Successfully");
              setIsCreate(false);
              loadData({ page: 1, sortBy: "-createdAt", limit: PAGE_LIMIT });
            }
          })
          .catch((err) => console.error(err));
      } else {
        invokeApi(
          HTTP_METHODS.POST,
          `${HOSTNAME}${REST_URLS.INTERNAL_CUTIN}`,
          payload
        )
          .then((res) => {
            if (res.message) {
              toast.error(res.message);
            } else {
              toast.success("Internal Cut-in Created Successfully");
              setIsCreate(false);
              loadData({ page: 1, sortBy: "-createdAt", limit: PAGE_LIMIT });
            }
          })
          .catch((err) => console.error(err));
      }
    }
  };
  const loadDefectCodes = () => {
    plainApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.GET_CODES}`, null, {
      type: "defect",
      page: 1,
      limit: 1000,
    })
      .then((response) => {
        if (response.results) {
          const codeList = response.results.map((ele) => ({
            label: `${ele.code}-${ele.description}`,
            value: ele.id,
          }));
          setDefectCodeList(codeList);
        }
      })
      .catch((err) => console.error(err));
  };
  const callBack = (newFile) => {
    setFiles([...files, newFile]);
  };
  const handleRegexSearch = (newInputValue) => {
    clearTimeout(oemTimeout);
    if (newInputValue) {
      oemTimeout = setTimeout(() => getOemList(newInputValue), 300);
    }
  };
  const getOemList = (filters) => {
    invokeApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.OEM_NAMES}`, null, {
      ...filters,
    })
      .then((response) => {
        if (response) {
          const result = response.map((ele) => ({
            label: ele.name,
            value: ele.id,
          }));
          setOemsList(result);
        }
      })
      .catch((err) => console.error(err));
  };
  const onDelete = (index) => {
    files.splice(index, 1);
    setFiles([...files]);
  };

  useEffect(() => {
    getOemList();
    loadDefectCodes();
  }, []);
  useEffect(() => {
    if (editData?.id) {
      const {
        plant,
        listNo,
        engineCutInNumber,
        cutInDate,
        oem,
        engineModel,
        complaint,
        action,
        uploadedDocument,
        defectCode,
      } = editData;
      setFormData((prevVal) => ({
        ...prevVal,
        plant,
        listNo,
        engineCutInNumber,
        cutInDate,
        oem: oemsList?.find((ele) => ele?.value === oem?.id),
        complaint,
        action,
        engineModel,
        defectCode: defectCodeList?.find(
          (ele) => ele?.value === defectCode?.id
        ),
      }));
      setFiles(uploadedDocument);
    }
  }, [oemsList, defectCodeList]);

  return (
    <div>
      <div className="form-con" style={{ width: "100%" }}>
        <FormGenerator
          config={getInternalCutInFormConfig(oemsList, defectCodeList)}
          formData={formData}
          setFormData={setFormData}
          errors={errors}
          setErrors={setErrors}
          fieldGridSize={3}
        />
        <Grid
          container
          sx={{ display: "flex", justifyContent: "space-between" }}
        ></Grid>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 2,
            mb: 2,

            alignItems: "center",
          }}
        >
          <div>
            <SiFileUpload id={null} callBack={callBack} />
          </div>
          <CustomButtonComponent
            variant="contained"
            color="primary"
            sx={{ width: "150px", ml: 2 }}
            onClick={submitHandler}
          >
            Submit
          </CustomButtonComponent>
        </Box>
        {files?.map((r, index) => {
          return (
            <div key={r.blobName + index}>
              {r.blobName ? (
                <span>{r.blobName}</span>
              ) : (
                <a href={r} target="_blank">
                  {getFileNameFromUrl(r)}
                </a>
              )}

              <IconButton onClick={() => onDelete(index)}>
                <CancelOutlinedIcon />
              </IconButton>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CreateServiceInformation;
